import { Component, ElementRef, EventEmitter, Inject, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit, Output, Renderer2, DOCUMENT } from '@angular/core';
import { CommonModule } from '@angular/common';
import { regEx } from '@app/core/constants/regEx';
import { PaymentService } from '../services/payment.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ProfileService } from '@app/core/services/profile.service';
import { DataService } from '@app/core/services/data.service';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';

@Component({
    selector: 'app-payment-card-details',
    imports: [ CommonModule, ReactiveFormsModule, SpinnerComponent, ConnectSlideComponent ],
    templateUrl: './payment-card-details.component.html',
    styleUrl: './payment-card-details.component.scss',
    schemas: [ NO_ERRORS_SCHEMA ],
})
export class PaymentCardDetailsComponent implements OnInit, OnDestroy {

    cardDetailsForm: any;

    constructor(private paymentService: PaymentService,
        private profileService: ProfileService,
        private adb2cService: Adb2cService,
        private dataService: DataService,
        private el: ElementRef, private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document) {
        this.cardDetailsForm = new FormGroup({
            defaultAddress: new FormControl(false),
            customAddress: new FormControl(false),
            lookupPostcode: new FormControl('', [
                Validators.required,
                // Validators.pattern(regEx.postCodePattern)
                Validators.pattern(regEx.nativePostCodePattern)
            ]),
            addressList: new FormControl(),
            addressLine1: new FormControl('', [
                Validators.required,
                Validators.max(250),
                Validators.pattern(regEx.addressPattern)
            ]),
            addressLine2: new FormControl('', [
                Validators.required,
                Validators.max(250),
                Validators.pattern(regEx.addressPattern)
            ]),
            addressLine3: new FormControl('', [
                Validators.max(350),
                Validators.pattern(regEx.addressPattern)
            ]),
            city: new FormControl('', [
                Validators.required,
                Validators.max(80),
                Validators.pattern(regEx.countryPattern)
            ]),
            county: new FormControl('', [
                Validators.required,
                Validators.max(80),
                Validators.pattern(regEx.countryPattern)
            ]),
            country: new FormControl('', [
                Validators.required,
                Validators.max(50),
                Validators.pattern(regEx.countryPattern)
            ]),
            postcode: new FormControl('', [
                Validators.required,
                Validators.max(50),
                Validators.pattern(regEx.postCodePattern)
            ]),
        });
    }

    @Input() number: string = "";
    @Input() active: boolean = false;
    @Input() complete: boolean = false;
    @Input() cardDetailsHeading: string = "";
    @Input() cardDetailsSubHeading: string = "";
    @Input() cardDetailsBody: string = "";
    @Input() paySecurelyButtonText: string = "";
    @Input() failedPaymentMessage: string = "";
    @Input() errorPaymentMessage: string = "";
    @Input() processingPaymentTitle: string = "";
    @Input() processingPaymentBody: string = "";
    @Input() slideId: string = "";
    @Input() paymentCardPageUrl: string = "";

    @Output() CompleteEvent = new EventEmitter<void>();
    @Output() BackEvent = new EventEmitter<void>();

    processingPayment: boolean = false;
    showError: boolean = false;
    showException: boolean = false;

    address: any;
    addresses: any = [];
    defaultAddress: any;
    paymentAmountText: string = "";
    cardDetailsBodyWithAmount: string = "";
    addressSelected: any;

    addressType: 'NONE' | 'DEFAULT' | 'CUSTOM' = 'NONE';
    addressSubType: 'AUTO' | 'MANUAL' = 'AUTO';

    useDefaultAddress: boolean = false;
    useCustomAddress: boolean = false;
    showManualAddress: boolean = false;
    showCardFront: boolean = true;
    postcodeFailure: boolean = false;
    submitted: boolean = false;
    //  isIe: document.documentMode,
    disableLabelChange: boolean = false;
    postcodeLookup = null;
    lastSlide = true;
    crmReference: any;
    private subscription: Subscription | undefined;
    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    payment = {
        amount: null,
        tenancyReference: "",
        applicationReference: "",
        account: "RENT",
        orderDescription: "order-description",
        currencyCode: "GBP",
        billingAddress: null,
        timezoneOffset: new Date().getTimezoneOffset(),
        isManualAddressEntry: false,
        location: ''
    };

    order: any;

    ngOnInit(): void {

        this.active = false;

        this.subscription = this.paymentService.subscribeOrder((data: any) => {

            this.payment.amount = data.amount;
            const amount = this.paymentService.convertToCurrencyText(data.amount, true);
            // Assuming vm.config.disableLabelChange is a property in this component
            if (!this.disableLabelChange) {
                this.paymentAmountText = this.paySecurelyButtonText?.replace("{amount}", amount);
                this.cardDetailsBodyWithAmount = this.cardDetailsBody?.replace("{amount}", amount);
            }
            this.order = data;
        }
        );
        // this.paymentService.subscribeOrder();

        this.getUserDetails();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
        this.subscription?.unsubscribe();
    }

    getUserDetails() {
        this.adb2cService.getUser();
        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            const userId = user?.sub ?? user?.oid; //sub is a copy of oid.  oid is more reliable for new signups
            if (user && userId) {
                if (user[ 'tenancy_reference' ]) {
                    this.payment.tenancyReference = user[ 'tenancy_reference' ];
                }

                console.log('call profile service for payment address details');
                this.profileService.getAddress(userId).subscribe({
                    next: (response) => {
                        console.log('payment address loaded from profile', response);
                        if (response) {
                            this.defaultAddress = response;
                        }
                    },
                    error: (error) => {
                        console.error(error)
                    }
                });
            }
        });

        //logger.info('attempt to load address');
    }

    onSubmit() {
        this.submitted = true;
        this.processingPayment = true;
        this.crmReference = sessionStorage.getItem('connect.crmReference');

        this.cardDetailsForm.updateValueAndValidity();

        if (this.addressType === 'NONE') {

            console.log('address check');
            this.processingPayment = false;
            //  vm.scrollTo("validation-errors");

            return;
        }

        // Check an address has been selected
        if ((this.addressType === 'CUSTOM' && this.addressSubType === 'AUTO') && (this.address === null || this.address === undefined)) {
            console.log('address selected check');
            this.processingPayment = false;
            //  vm.scrollTo("validation-errors");
            return;
        }

        // catch regular ng errors
        if (this.cardDetailsForm?.errors != null) {
            const errors = this.cardDetailsForm?.errors;
            console.log('form errors', errors);
            this.processingPayment = false;
            return;
        }

        // Now check the actual form is valid
        if (this.cardDetailsForm?.valid) {
            // Map custom address to the payment address
            if (this.addressType === 'CUSTOM') {
                const customAddress: any = {
                    addressLine1: this.cardDetailsForm.get('addressLine1')!.value,
                    addressLine2: this.cardDetailsForm.get('addressLine2')!.value,
                    addressLine3: this.cardDetailsForm.get('addressLine3')!.value,
                    city: this.cardDetailsForm.get('city')!.value,
                    county: this.cardDetailsForm.get('county')!.value,
                    country: this.cardDetailsForm.get('country')!.value,
                    postcode: this.cardDetailsForm.get('postcode')!.value
                }

                this.payment.billingAddress = customAddress;
                this.payment.isManualAddressEntry = true; //PHX-783: Need to set this flag so we can distinguish server-side between a postcode lookup address and a manually entered address
            } else {
                this.payment.billingAddress = this.defaultAddress;
            }

            console.log("submitting payment with address: ", this.payment.billingAddress);
            // Every thing is valid so lets make the payment

            this.payment.applicationReference = sessionStorage.getItem('connect.crmReference') ?? "";
            this.payment.location = window.location.href; //WORKAROUND: Added by CM - API will check this to determine type of payment

            console.log('PaymentCardDetailsComponent - VM object', this);
            console.log('PaymentCardDetailsComponent - VM - Window.Location.HREF', window.location.href);

            const form = document.createElement('form');
            form.style.visibility = 'hidden';
            form.method = 'POST';
            form.action = this.paymentCardPageUrl;

            Object.entries(this.payment).forEach(([ key, value ]) => {
                if (value !== null && typeof value !== 'object') {
                    const input = document.createElement('input');
                    input.name = key;
                    input.value = value.toString();
                    form.appendChild(input);
                }
            });

            if (this.payment.billingAddress) {
                Object.entries(this.payment.billingAddress).forEach(([ key, value ]) => {
                    if (value !== null && typeof value !== 'object') {
                        const input = document.createElement('input');
                        input.name = key;
                        input.value = (value ?? "").toString();
                        form.appendChild(input);
                    }
                });
            }

            document.body.appendChild(form);
            form.submit();

            return;
        }


    }

    setShowManualAddress() {
        this.addressSubType = 'MANUAL';

        this.setLookupPostcodeValidator(false);
        this.setCustomAddressValidators(true);
    }

    toggleCheckbox(option: string) {
        const defaultAddressValue = this.cardDetailsForm?.get('defaultAddress')!.value;
        const customAddressValue = this.cardDetailsForm?.get('customAddress')!.value;

        if ((option === 'defaultAddress' && defaultAddressValue === true && customAddressValue === false) ||
            (option === 'customAddress' && customAddressValue === true && defaultAddressValue === false)) {
            this.setLookupPostcodeValidator(true);
            this.setCustomAddressValidators(true);

            this.addressType = 'NONE';
            this.addressSubType = 'AUTO';

            return;
        }

        if (option === 'defaultAddress') {
            this.cardDetailsForm.get('defaultAddress')?.patchValue(true);
            this.cardDetailsForm.get('customAddress')?.patchValue(false);

            this.addressType = 'DEFAULT';

            this.setLookupPostcodeValidator(false);
            this.setCustomAddressValidators(false);

            return;
        }

        if (option === 'customAddress') {
            this.cardDetailsForm.get('customAddress')?.patchValue(true);
            this.cardDetailsForm.get('defaultAddress')?.patchValue(false);

            this.addressType = 'CUSTOM';

            this.setLookupPostcodeValidator(true);
            this.setCustomAddressValidators(true);

            return;
        }
    }

    getAddresses() {
        this.postcodeFailure = false;
        this.postcodeLookup = this.cardDetailsForm?.get('lookupPostcode')?.value;
        this.dataService.getAddressesForPostcode(this.postcodeLookup ?? "")
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.addresses = response;
                    } else {
                        this.postcodeFailure = true;
                    }
                },
                error: (error) => {
                    this.postcodeFailure = true;
                    console.log(error);
                }
            });
        this.addressSelected = null;
    }

    onBack() {
        this.BackEvent.emit();
    }

    // @HostListener('keydown', [ '$event' ])
    // onKeyDown(event: KeyboardEvent): void {
    //     // Allow backspaces, tabs, and arrow keys
    //     if (event.key === 'Backspace' || event.key === 'Tab' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    //         return;
    //     }

    //     // Block non-numeric characters, periods (full stops), and spaces
    //     const regex = new RegExp("^[0-9]+$");
    //     if (!regex.test(event.key) || event.key === '.' || event.key === ' ') {
    //         event.preventDefault();
    //     }
    // }

    // @HostListener('keyup', [ '$event' ])
    // onKeyUpExpiryMonth(event: KeyboardEvent): void {
    //     const tabOrShift = event.key === 'Tab' || event.key === 'Shift' || event.key === 'ArrowLeft' || event.key === 'ArrowRight';
    //     const inputElement = event.target as HTMLInputElement;

    //     if (!tabOrShift && inputElement.value.length === 2) {
    //         // Tab to element with given class.
    //         // We're not using id and name here to stop
    //         // things being sent to our servers.
    //         // The class name is supposed to be weird
    //         const nextInput = this.el.nativeElement.querySelector('.input-next-target');
    //         this.renderer.selectRootElement(nextInput).focus();
    //     }
    // }

    // ngOnChanges(changes: SimpleChanges): void {
    //     if (changes[ 'addressSelected' ]) {
    //         console.log(changes[ 'addressSelected' ])

    //         console.log(this.addressSelected)
    //         this.address = this.addresses[ this.addressSelected ];
    //         console.log(this.address);
    //     }
    // }

    setAddressSelected() {

        console.log("Address Selection")
        const idx = this.cardDetailsForm?.controls[ 'addressList' ].value;
        this.address = this.addresses[ idx ];
        this.cardDetailsForm?.patchValue({
            addressLine1: this.address.addressLine1,
            addressLine2: this.address.addressLine2,
            addressLine3: this.address.addressLine3,
            city: this.address.city,
            county: this.address.county,
            country: this.address.country,
            postcode: this.address.postCode
        });
        console.log("Address selected", this.address);
    }

    scrollTo(id: string): void {
        setTimeout(() => {
            const element = this.document.getElementById(id);
            if (element) {
                if (this.isBreakpointXS()) {
                    element.scrollIntoView(); // For XS, immediate scroll
                } else {
                    // For non-XS, smooth scroll
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }, 350);
    }

    isBreakpointXS(): boolean {
        return window.matchMedia('(max-width: 576px)').matches; // Example for 'xs' breakpoint
    }

    // isValidHelper(field:FormControl) {
    //     var required = field.validator.required !== undefined;

    //     return (field.$valid && field.$pristine && required) ||
    //            (field.$valid && field.$dirty) ||
    //            (field.$valid && field.$touched) ||
    //            (field.$valid && vm.config.submitted);
    // };

    isInvalidHelper(field: FormControl) {
        return (field.invalid && field.dirty) ||
            (field.invalid && field.touched) ||
            (field.invalid && this.submitted);
    }

    // scrollTo(id:string){
    //     $timeout(function () {

    //         var element = document.getElementById(id);
    //         var ngElement = angular.element(element);

    //         if (Breakpoint.is('xs')) {
    //             $document.scrollToElement(ngElement);
    //         } else {
    //             $document.scrollToElementAnimated(ngElement);
    //         }

    //     }, 350);
    // }


    // formatAddress(address: any): string {
    //     return `${address.addressLine1} ${address.addressLine2}, ${address.addressLine3}, ${address.city}, ${address.county}, ${address.country}`
    //         .replace(/,,+/g, ',') // Replace multiple consecutive commas with a single comma
    //         .replace(/^,|,$/g, ''); // Remove leading and trailing commas
    // }

    private setLookupPostcodeValidator(value: boolean) {
        const lookupPostcodeControl = this.cardDetailsForm.get('lookupPostcode')!;
        if (value === true) {
            lookupPostcodeControl.addValidators(
                [
                    Validators.required,
                    Validators.pattern(regEx.nativePostCodePattern)
                ]);
        } else {
            lookupPostcodeControl.clearValidators();
        }
        lookupPostcodeControl.updateValueAndValidity();
    }

    private setCustomAddressValidators(value: boolean) {
        const addressLine1Control = this.cardDetailsForm.get('addressLine1')!;
        const addressLine2Control = this.cardDetailsForm.get('addressLine2')!;
        const cityControl = this.cardDetailsForm.get('city')!;
        const countyControl = this.cardDetailsForm.get('county')!;
        const countryControl = this.cardDetailsForm.get('country')!;
        const postcodeControl = this.cardDetailsForm.get('postcode')!;

        if (value) {
            addressLine1Control.addValidators([ Validators.required ]);
            addressLine2Control.addValidators([ Validators.required ]);
            cityControl.addValidators([ Validators.required ]);
            countyControl.addValidators([ Validators.required ]);
            countryControl.addValidators([ Validators.required ]);
            postcodeControl.addValidators([ Validators.required ]);
        } else {
            addressLine1Control.removeValidators([ Validators.required ]);
            addressLine2Control.removeValidators([ Validators.required ]);
            cityControl.removeValidators([ Validators.required ]);
            countyControl.removeValidators([ Validators.required ]);
            countryControl.removeValidators([ Validators.required ]);
            postcodeControl.removeValidators([ Validators.required ]);
        }

        addressLine1Control.updateValueAndValidity();
        addressLine2Control.updateValueAndValidity();
        cityControl.updateValueAndValidity();
        countyControl.updateValueAndValidity();
        countryControl.updateValueAndValidity();
        postcodeControl.updateValueAndValidity();
    }
}
